import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '重庆体彩特约上游运动家短视频挑战赛';

const route: RouteConfig = {
  path: '/20200203TCTYSYYDJ',
  name: 'TCTYSYYDJ',
  component: () => import('./Home.vue'),
  redirect: '/20200203TCTYSYYDJ/works',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'works',
      component: () => import('./Works.vue'),
      name: '20200203TCTYSYYDJ/works',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'signUp',
      component: () => import('./SignUp.vue'),
      name: '20200203TCTYSYYDJ/SignUp',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200203TCTYSYYDJ/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'relativeNews',
      component: () => import('./RelativeNews.vue'),
      name: '20200203TCTYSYYDJ/relativeNews',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'detail',
      component: () => import('./DetailPage.vue'),
      name: '20200203TCTYSYYDJ/detail',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
